export default __webpack_public_path__ + "static/media/2004.a48d31f8.png";